import React from 'react';
import MetaHelmet from '../../components/MetaHelmet';
import Footer from '../../components/footer';
import Header from '../../components/Header';
import navigationBackground from '../../../assets/Images/navigationBackground.png';

const NoRoute = () => (
  <>
    <MetaHelmet title="Page Not Found (404)" />
    <section>
      <div>
        <div
          className="background-header"
          style={{
            backgroundImage: `url(${navigationBackground})`,
          }}
        >
          <Header />
        </div>
      </div>
      <div className="grid-container width-100 padding-vertical-2 padding-horizontal-2">
        <div className="grid-x grid-padding-x">
          <div className="cell small-12 medium-12">
            <h1>Error - Page Not Found</h1>
            <p>
              Sorry, this page does not exist. Please return home using the
              navigation in the top right corner of the website.
            </p>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </>
);

export default NoRoute;
